module.exports = __webpack_public_path__ + "img/euro-tax.bg.25b6fc1e.svg";